export class Storage {
    constructor(name) {
        this.name = name
    }
    set(value){
        localStorage.setItem(this.name, JSON.stringify(value));
    }
    get(){
        return JSON.parse(localStorage.getItem(this.name))
    }
    remove(){
        localStorage.removeItem(this.name);
    }
}
export default Storage



// WEBPACK FOOTER //
// ./src/util/storage.js